import { render, staticRenderFns } from "./GroupRequestDetails.vue?vue&type=template&id=fd24732e"
import script from "./GroupRequestDetails.vue?vue&type=script&lang=js"
export * from "./GroupRequestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports